import { Component, h, Host, Prop } from "@stencil/core";

/**
 * @slot (default) - Slot for the card content
 */
@Component({
    tag: "ux-iws-sf-card-content",
    styleUrl: "sf-card-content.scss",
    shadow: true,
})
export class SfCardContent {
    /** The label for the card, also used for accessibility. */
    @Prop() label: string = "";

    /** Indicates if the card body should have no padding */
    @Prop({ reflect: true }) noPadding: boolean = false;

    render() {
        return (
            <Host>
                {this.label && <div class="label">{this.label}</div>}
                <slot />
            </Host>
        );
    }
}
